module.exports = __webpack_public_path__ + "img/fluid-handling.47e569d3.png";